import React from 'react';
import { FormControlLabel, InputAdornment, Switch, TextField } from '@mui/material';
import { previewProductCode, productCodeWidth } from './utils';

// Code entry for tenants with productCode settings: a prefix code or, if allowed, a typed barcode.
const ProductCodeField = ({ settings, nextCode, entry, onChange }) => {
  const width = productCodeWidth(settings);
  const preview = previewProductCode(settings, entry.number);
  const update = (changes) => onChange({ ...entry, ...changes });

  return (
    <div style={{ marginBottom: '16px' }}>
      {settings.allowBarcode && (
        <FormControlLabel
          control={(
            <Switch
              checked={entry.useBarcode}
              onChange={(event) => update({ useBarcode: event.target.checked })}
            />
          )}
          label="Use barcode"
        />
      )}
      {entry.useBarcode ? (
        <TextField
          label="Code"
          value={entry.barcode}
          onChange={(event) => update({ barcode: event.target.value })}
          required
          fullWidth
        />
      ) : settings.lockNumber ? (
        <TextField
          label="Code"
          value={nextCode}
          helperText="Assigned when saved"
          InputProps={{ readOnly: true }}
          fullWidth
        />
      ) : (
        <TextField
          label="Number"
          value={entry.number}
          onChange={(event) => update({ number: event.target.value.replace(/\D/g, '').slice(0, width) })}
          helperText={preview ? `Code: ${preview}` : `Up to ${width} digits`}
          InputProps={{ startAdornment: <InputAdornment position="start">{settings.prefix}</InputAdornment> }}
          inputProps={{ inputMode: 'numeric' }}
          required
          fullWidth
        />
      )}
    </div>
  );
};

export default ProductCodeField;
